import { Modal, StyleSheet, Text, View } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';

const LeaveAppDialog = () => {
	const { pendingUrl, description, cancel, confirm } = useLeaveAppStore();

	return (
		<Modal
			animationType="fade"
			style={dialogStyles.modalView}
			transparent={true}
			visible={pendingUrl !== null}
			onRequestClose={() => cancel()}
		>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<View style={styles.iconCircle}>
						<SvgIcon name={SvgIconType.externalLink} size={Dimens.iconSize24} tintColor={Colors.gray800} />
					</View>

					<Text style={dialogStyles.modalTitle}>{Translations.leaveAppTitle}</Text>
					<Text style={dialogStyles.modalDescription}>{description}</Text>

					<PrimaryButton label={Translations.leaveAppConfirm} onPress={() => confirm()} />
					<SecondaryButton extraStyle={styles.cancelButton} label={Translations.cancel} onPress={() => cancel()} />
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	iconCircle: {
		width: Dimens.size56,
		height: Dimens.size56,
		borderRadius: Dimens.borderRadiusPill,
		alignItems: 'center',
		justifyContent: 'center',
		alignSelf: 'center',
		backgroundColor: Colors.gray75,
		marginBottom: Dimens.padding20,
	},
	cancelButton: {
		marginTop: Dimens.padding12,
	},
});

export default LeaveAppDialog;
